import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { AtiraTabs } from '../../components/AtiraTabs';
import { Flex } from '../../components/Flex';
import { UserHeader } from '../../components/UserHeader';
import { atiraLinkSliceSelectors } from '../../redux/atira-link/atira-link.selector';
import { useAppSelector } from '../../redux/store';
import { Breakpoints } from '../../theme/Breakpoints';
import { Spacing } from '../../theme/Spacing';
import { TabsProps } from '../../utils/local-antd';
import { SettingsBrand } from './tabs/SettingsBrand';
import { SettingsCustomAnalytics } from './tabs/SettingsCustomAnalytics';
import { SettingsGeneral } from './tabs/SettingsGeneral';
import { SettingsIndex } from './tabs/SettingsIndex';
import { SettingsLanguage } from './tabs/SettingsLanguage';
import { SettingsOpenGraph } from './tabs/SettingsOpenGraph';
import { SettingsSelfHosting } from './tabs/SettingsSelfHosting';

const UserHeaderWrapper = styled(Flex)`
  display: none;
  padding-top: ${Spacing.s};

  @media (min-width: ${Breakpoints.DESKTOP}) {
    display: flex;
  }
`;

const SettingsTabs = styled(AtiraTabs)`
  .ant-tabs-nav-list {
    margin-inline-end: 0;
    margin-inline-end: ${Spacing.m};
    margin-block-start: ${Spacing.l};
  }
`;

export const SettingsRoute: React.FC = () => {
  const { t } = useTranslation();

  const userAtiraLinks = useAppSelector(
    atiraLinkSliceSelectors.selectUserAtiraLinks,
  );

  const showBrandTab = userAtiraLinks?.length > 0;

  const items = [
    {
      key: 'general',
      label: t('common.general'),
      children: <SettingsGeneral />,
    },
    {
      key: 'link-index',
      label: t('common.index'),
      children: <SettingsIndex />,
    },
    showBrandTab
      ? {
          key: 'brand',
          label: t('common.brand'),
          children: <SettingsBrand />,
        }
      : null,
    {
      key: 'open-graph',
      label: t('settings.open_graph'),
      children: <SettingsOpenGraph />,
    },
    {
      key: 'self-hosting',
      label: t('settings.self_hosting'),
      children: <SettingsSelfHosting />,
    },
    {
      key: 'link-lang',
      label: t('common.language'),
      children: <SettingsLanguage />,
    },
    {
      key: 'custom-analytics',
      label: t('settings.customAnalytics'),
      children: <SettingsCustomAnalytics />,
    },
  ].filter(Boolean) as TabsProps['items'];

  return (
    <SettingsTabs
      items={items}
      sideComponent={
        <UserHeaderWrapper>
          <UserHeader />
        </UserHeaderWrapper>
      }
    />
  );
};
